'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _experiments = require('../experiments');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlassboxLoader = function () {
  function GlassboxLoader(emitter, options) {
    (0, _classCallCheck3.default)(this, GlassboxLoader);

    this._emitter = emitter;
    this._options = options;
  }

  (0, _createClass3.default)(GlassboxLoader, [{
    key: '_shouldRecord',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var mustRecord;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mustRecord = window.location.toString().indexOf('alwaysgb') !== -1;

                if (!mustRecord) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', true);

              case 3:
                return _context.abrupt('return', window === window.top && (0, _experiments.conductExperiment)('specs.fedinfra.Glassbox'));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _shouldRecord() {
        return _ref.apply(this, arguments);
      }

      return _shouldRecord;
    }()
  }, {
    key: '_isContainerRecording',
    value: function _isContainerRecording() {
      var _this = this;

      return new _promise2.default(function (resolve) {
        var removeListener = function removeListener() {};

        var timeout = setTimeout(function () {
          removeListener();
          resolve(false);
        }, 100);

        removeListener = _this._emitter.listenOnce('WIX_GLASSBOX_PONG', function () {
          clearTimeout(timeout);
          resolve(true);
        });

        _this._emitter.emit('WIX_GLASSBOX_PING', _this._options.label, window.parent);
      });
    }
  }, {
    key: '_setupListeners',
    value: function _setupListeners() {
      var _this2 = this;

      this._emitter.listen('WIX_GLASSBOX_PING', function (e, payload) {
        if (_this2._isChild) {
          _this2._emitter.emit('WIX_GLASSBOX_PING', payload, window.parent);
        }
        _this2._emitter.emit('WIX_GLASSBOX_PONG', '', e.source, e.origin);
      });
    }
  }, {
    key: '_objectParamsToScriptParams',
    value: function _objectParamsToScriptParams(object) {
      return (0, _keys2.default)(object).map(function (key) {
        return key + '=' + object[key];
      }).join(';');
    }
  }, {
    key: '_load',
    value: function _load() {
      var _this3 = this;

      var defaultConfig = {
        recordScrolls: true,
        recordMouseMoves: true,
        idleEventTimeInterval: -1,
        recordErrors: false,
        recordHovers: true,
        domRecordEnabled: true,
        domHashTokens: true,
        reportByPost: true,
        iframesAutoInject: false
      };

      var attributes = {
        async: true,
        'data-clsconfig': this._objectParamsToScriptParams(defaultConfig)
      };

      return new _promise2.default(function (resolve) {
        utils.lazyLoadScript('//cdn.glassboxcdn.com/wix/detector-dom.min.js', '_cls_detector', function () {
          _this3._options.onReady && _this3._options.onReady();
          resolve();
        }, attributes);
      });
    }
  }, {
    key: '_qaGlassbox',
    value: function _qaGlassbox() {
      return window.location.toString().indexOf('qagb') !== -1 || this._options.qagb === true;
    }
  }, {
    key: 'setup',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var startGlassBox;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._isChild = window !== window.top;

                if (!(!this._qaGlassbox() && !this._isChild)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.t0 = this._isChild;

                if (!_context2.t0) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return this._isContainerRecording();

              case 7:
                _context2.t0 = _context2.sent;

              case 8:
                if (!_context2.t0) {
                  _context2.next = 14;
                  break;
                }

                this._setupListeners();
                _context2.next = 12;
                return this._load();

              case 12:
                _context2.next = 22;
                break;

              case 14:
                _context2.next = 16;
                return this._shouldRecord().catch(function () {
                  return false;
                });

              case 16:
                startGlassBox = _context2.sent;

                if (!startGlassBox) {
                  _context2.next = 22;
                  break;
                }

                this._isChild = false;

                this._setupListeners();
                _context2.next = 22;
                return this._load();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setup() {
        return _ref2.apply(this, arguments);
      }

      return setup;
    }()
  }]);
  return GlassboxLoader;
}();

exports.default = GlassboxLoader;